import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-invoice-retry-modal',
  templateUrl: './invoice-retry-modal.component.html',
  styleUrls: ['./invoice-retry-modal.component.scss'],
})
export class InvoiceRetryModalComponent {
  deadHead: boolean;
  flightTime: boolean;
  layoverTime: boolean;
  showUsd: boolean;
  formData: { deadHead: boolean; flightTime: boolean; layoverTime: boolean } = {
    deadHead: false,
    flightTime: true,
    layoverTime: false,
  };
  selectedCurrency: { showUsd: boolean } = {
    showUsd: false,
  };
  constructor(
    public dialogRef: MatDialogRef<InvoiceRetryModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      callbackMethod: (form: any) => void;
      module: string;
    }
  ) {
    this.deadHead = false;
    this.flightTime = false;
    this.layoverTime = false;
    this.showUsd = false;
  }

  onCancelClick(): void {
    this.dialogRef.close({ success: 'false' });
  }
  onSubmit() {
    if (this.data.module === 'FINANCE') {
      this.data.callbackMethod(this.selectedCurrency);
    } else {
      if (this.data && this.data.callbackMethod) {
        this.data.callbackMethod(this.formData);
      }
    }

    this.dialogRef.close({ success: 'true' });
  }
}
